export const GOP = '#f27e7d';
export const GOP_DARK = '#f9c1c1';
export const GOP_LIGHT = '#f9c0be';
export const DEMOCRAT = '#5788b8';
export const DEMOCRAT_DARK = '#abc3db';
export const DEMOCRAT_LIGHT = '#a7c8e0';
export const GREEN = '#7BC8AF';
export const LIBERTARIAN = '#EDDB80';
export const OTHER = '#5e7485';
export const OTHER_LIGHT = '#a9b4bd';

// Trends (U.S. House, Senate, governor) only
export const TRENDS_OTHER = '#EACC4E';
export const TRENDS_OTHER_STROKE = '#D1AF24';

export const NEUTRAL = '#E7E7E7';
export const TIE = '#f9cd61';

const colorLookup = new Map([
  ['R', GOP],
  ['D', DEMOCRAT],
  // ['gre', GREEN],
  // ['lib', LIBERTARIAN],
]);

const caColorLookup = new Map([
  ['gop', GOP_LIGHT],
  ['dem', DEMOCRAT_LIGHT],
  // ['gre', GREEN],
  // ['lib', LIBERTARIAN],
]);

/** @param {string} party */
export function getColor(party) {
  return colorLookup.get(party) || OTHER;
}

/** @param {string} party */
export function getCAColor(party) {
  return caColorLookup.get(party) || OTHER;
}

const hatchFillCache = new Map();

/** @param {string} fillStyle */
export function createHatchFill(fillStyle) {
  if (hatchFillCache.has(fillStyle)) {
    return hatchFillCache.get(fillStyle);
  }

  const patternSize = 7;
  const divisions = 4;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const dpi = window.devicePixelRatio || 1;

  ctx.scale(dpi, dpi);

  canvas.width = patternSize;
  canvas.height = patternSize;

  if (fillStyle === GOP) {
    ctx.fillStyle = GOP_DARK;
    ctx.fillRect(0, 0, patternSize, patternSize);
  }

  if (fillStyle === DEMOCRAT) {
    ctx.fillStyle = DEMOCRAT_DARK;
    ctx.fillRect(0, 0, patternSize, patternSize);
  }

  if (fillStyle === OTHER) {
    ctx.fillStyle = OTHER_LIGHT;
    ctx.fillRect(0, 0, patternSize, patternSize);
  }

  ctx.fillStyle = fillStyle;

  // Top line
  ctx.beginPath();
  ctx.moveTo(0, patternSize * (1 / divisions));
  ctx.lineTo(patternSize * (1 / divisions), 0);
  ctx.lineTo(0, 0);
  ctx.lineTo(0, patternSize * (1 / divisions));
  ctx.fill();
  ctx.closePath();

  // Middle line
  ctx.beginPath();
  ctx.moveTo(patternSize, patternSize * (1 / divisions));
  ctx.lineTo(patternSize * (1 / divisions), patternSize);
  ctx.lineTo(0, patternSize);
  ctx.lineTo(0, patternSize * ((divisions - 1) / divisions));
  ctx.lineTo(patternSize * ((divisions - 1) / divisions), 0);
  ctx.lineTo(patternSize, 0);
  ctx.lineTo(patternSize, patternSize * (1 / divisions));
  ctx.fill();
  ctx.closePath();

  // Bottom line
  ctx.beginPath();
  ctx.moveTo(patternSize, patternSize * ((divisions - 1) / divisions));
  ctx.lineTo(patternSize * ((divisions - 1) / divisions), patternSize);
  ctx.lineTo(patternSize, patternSize);
  ctx.lineTo(patternSize, patternSize * ((divisions - 1) / divisions));
  ctx.fill();
  ctx.closePath();

  const pattern = ctx.createPattern(canvas, 'repeat');

  hatchFillCache.set(fillStyle, pattern);
  return pattern;
}
